export let layout = {
	getRatio: function($target){
		let $header = document.querySelector("header");
		
		let winW = window.innerWidth;
		let winH 	= window.innerHeight;
		let areaH = winH - $header.clientHeight;
		const baseRatio = 1275 / 698;
		const currentRatio = winW / areaH;
		let $main = document.querySelector("main");
		$main.className = "";
		if (currentRatio > baseRatio) {
			// 横長（基準より横に余裕がある）
			$main.classList.add("v");
		} else {
			// 縦長（基準より縦に余裕がある）
			$main.classList.add("h");
		}
	},
	resize: function( isStart ){
		let $target = document.querySelector("#c-cards");
		let winH 	= window.innerHeight;
		
		layout.getRatio( $target );
		
		let $html 	= document.documentElement;
		let yLen 	= 0;
		let xLen 	= 0;
		let $lists 	= $target.querySelectorAll("li.card");
		let marginX = getPx( getComputedStyle(document.documentElement).getPropertyValue('--card-margin') );
		if( window.innerWidth <= 640 ){
			xLen = 4;
		}else if(window.innerWidth <= 768){
			xLen = 5;
		}else{
			xLen = 8;
			marginX = getPx( getComputedStyle(document.querySelector("main")).getPropertyValue('--card-margin') );
		}
		yLen = $lists.length / xLen;
		//console.log(xLen, yLen)
		let cardSize = [0, 0];
		cardSize[0] = $lists[0].clientWidth;
		cardSize[1] = $lists[1].clientHeight;
		let count = 0;
		for( let y = 0; y < yLen; y++ ){
			for( let x = 0; x < xLen; x++){
				let c = $lists[count];
				if( c ){
					let _x = Math.floor( ( cardSize[0] + marginX)*x );
					let _y = Math.floor( ( cardSize[1] + marginX)*y );
					//console.log(c);
					c.setAttribute("data-x", _x);
					c.setAttribute("data-y", _y);
					
					if( isStart ){
						//カードの正位置に表示
						c.style.transform = `translate3d(${_x}px, ${_y}px, 0)`;
					}else{
						//中央、下に配置
						let startX = $target.clientWidth/2 - cardSize[0]/2;
						let startY = window.innerHeight + cardSize[1]*2;
						c.style.transform = `translate3d(${startX}px, ${startY}px, 0)`;
					}
					count++;
				}
			}
		}
		console.log('%cresize-------------------', 'color: white; background-color: green;');

	}
}
let getPx = (vw) =>{
	let $main = document.querySelector("main");
	if( window.innerWidth <= 768 ){
		return parseFloat(vw) * (window.innerWidth / 100);
	}else{
		if( $main.classList.contains("v") ){
			return parseFloat(vw.replace("vh", "")) * (window.innerHeight / 100);
		}else if( $main.classList.contains("h") ){
			return parseFloat(vw.replace("vw", "")) * (window.innerWidth / 100);
		}
	}
}